import React from 'react';
import { useTranslation } from 'react-i18next';
import { getDotColor } from '../../commonFunctions';
import { sensorUnits } from '../../constants';
import { SensorTypes } from '../../models/commonEnums';
import { SensorStatusCircleWithIcon } from './SensorStatusDot';

type Props = {
    thresholds: number[];
    value: number | undefined;
    unit: keyof typeof sensorUnits;
    sensorType: SensorTypes;
    lld: number | undefined;
};

export const CircledSensorUnitComponent = ({ thresholds, value, unit, sensorType, lld }: Props): React.ReactElement => {
    const { t: txt } = useTranslation();
    const sensorHasValue = value !== undefined && value !== null && !Number.isNaN(value);
    const displayLldValue = !!(lld && value) && lld > value;
    let displayedValue: string | number | undefined = displayLldValue ? lld : value;
    const statusColor = getDotColor(thresholds, sensorType, displayedValue);
    const displayedUnit = unit && sensorUnits[unit];
    if (displayedValue) {
        displayedValue =
            displayedValue && displayedUnit === sensorUnits.pci ? displayedValue.toFixed(1) : displayedValue.toFixed(0);
    }

    return (
        <div className="insight-tile__content insight-tile__content--sensor">
            <SensorStatusCircleWithIcon color={statusColor} sensor={sensorType} />
            <div className="sensor__data">
                <div className="sensor__unit--top">{displayedUnit}</div>
                <span className="sensor__value">
                    {sensorHasValue
                        ? `${displayLldValue ? '<' : ''}${displayedValue}`
                        : txt('NotAvailableAbbreviation')}
                </span>
            </div>
        </div>
    );
};

export default CircledSensorUnitComponent;
